import logo from './logo.svg';
import './App.css';
import './Components/Home'
import Home from './Components/Home';

function App() {
  return (
    <div className="App">
      <Home/>
    </div>
  );
}

export default App;
